import * as React from 'react';

export const RequiredIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={props.width || 10} height={props.height || 9.6} style={props?.style} viewBox="0 0 12 13" fill="none">
    <g clipPath="url(#clip0_1393_2033)">
      <path
        d="M7.57623 0.694458L7.07703 5.15894L11.5994 3.8933L12.0001 6.95282L7.87812 7.2431L10.5834 10.8425L7.83163 12.3055L5.93903 8.51447L4.27873 12.2822L1.41665 10.8425L4.09873 7.2431L0 6.92376L0.470281 3.8933L4.89996 5.15894L4.40063 0.694458H7.57623Z"
        fill={props.fill || '#B5121B'}
      />
    </g>
    <defs>
      <clipPath id="clip0_1393_2033">
        <rect width="12" height="11.611" fill="white" transform="translate(0 0.694458)" />
      </clipPath>
    </defs>
  </svg>
);
